const init = function () {
    const toggleBtn = document.getElementById('sidebar-toggle');
    const shell = document.getElementById('app-shell');

    if (!toggleBtn || !shell) return;

    // Check local storage for persistence (client side)
    const isCollapsed = localStorage.getItem('sidebar_collapsed') === 'true';
    if (isCollapsed) {
        shell.classList.add('sidebar-collapsed');
    }

    toggleBtn.addEventListener('click', function () {
        const nowCollapsed = shell.classList.toggle('sidebar-collapsed');
        localStorage.setItem('sidebar_collapsed', nowCollapsed);
        document.cookie = "sidebar_collapsed=" + (nowCollapsed ? "1" : "0") + "; path=/; max-age=31104000";

        // Update icon
        const icon = toggleBtn.querySelector('i');
        if (nowCollapsed) {
            icon.classList.replace('bi-list', 'bi-text-indent-left');
        } else {
            icon.classList.replace('bi-text-indent-left', 'bi-list');
        }
    });

    // Initial icon state
    if (isCollapsed) {
        const icon = toggleBtn.querySelector('i');
        if (icon) icon.classList.replace('bi-list', 'bi-text-indent-left');
    }
}
export default {init};
